(() => {
  if (window.IamaranthProductCardPurchase) return;
  window.IamaranthProductCardPurchase = true;

  const consentText = 'Acepto que Iamaranth realice cargos automáticos recurrentes por esta suscripción, conforme a la periodicidad, monto y condiciones indicadas.';
  const root = window.Shopify?.routes?.root || '/';

  const syncPurchaseCard = (card) => {
    const selected = card.querySelector('[data-purchase-choice]:checked');
    const consentWrap = card.querySelector('[data-purchase-consent-wrap]');
    const consent = card.querySelector('[data-purchase-consent]');
    const checkout = card.querySelector('[data-purchase-checkout]');
    const isSubscription = Boolean(selected?.dataset.sellingPlan);

    if (consentWrap) consentWrap.hidden = !isSubscription;
    if (consent) {
      consent.required = isSubscription;
      if (!isSubscription) consent.checked = false;
    }
    checkout.disabled = isSubscription && !consent?.checked;
    checkout.textContent = isSubscription ? 'Suscribirme y continuar' : 'Comprar ahora';
  };

  document.addEventListener('click', async (event) => {
    const toggle = event.target.closest('[data-purchase-toggle]');
    if (toggle) {
      const card = toggle.closest('[data-product-card-purchase]');
      const panel = card.querySelector('[data-purchase-panel]');
      const willOpen = panel.hidden;
      document.querySelectorAll('[data-purchase-panel]').forEach((other) => {
        if (other !== panel) {
          other.hidden = true;
          other.closest('[data-product-card-purchase]')?.querySelector('[data-purchase-toggle]')?.setAttribute('aria-expanded', 'false');
        }
      });
      panel.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', String(willOpen));
      if (willOpen) syncPurchaseCard(card);
      return;
    }

    const checkout = event.target.closest('[data-purchase-checkout]');
    if (!checkout) return;
    const card = checkout.closest('[data-product-card-purchase]');
    const selected = card.querySelector('[data-purchase-choice]:checked');
    const consent = card.querySelector('[data-purchase-consent]');
    const status = card.querySelector('[data-purchase-status]');
    const sellingPlan = selected?.dataset.sellingPlan ? Number(selected.value) : null;

    if (sellingPlan && !consent?.checked) {
      status.textContent = 'Confirma el consentimiento para continuar con la suscripción.';
      syncPurchaseCard(card);
      return;
    }

    checkout.disabled = true;
    status.textContent = 'Preparando tu checkout seguro…';
    const item = { id: Number(card.dataset.variantId), quantity: 1 };
    if (sellingPlan) item.selling_plan = sellingPlan;

    try {
      const addResponse = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [item] }),
      });
      if (!addResponse.ok) throw new Error('No fue posible agregar el producto al carrito. Intenta nuevamente.');

      if (sellingPlan) {
        await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: {
            subscription_consent: 'accepted',
            subscription_consent_at: new Date().toISOString(),
            subscription_consent_text: consentText,
          } }),
        });
      }
      window.location.assign(`${root}checkout`);
    } catch (error) {
      status.textContent = error instanceof Error ? error.message : 'Ocurrió un error. Intenta nuevamente.';
      syncPurchaseCard(card);
    }
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-purchase-choice], [data-purchase-consent]')) return;
    const card = event.target.closest('[data-product-card-purchase]');
    if (card) syncPurchaseCard(card);
  });
})();
